// Module
var code = "<p ng-if=\"!component.content\">{{ 'HTML Element with no content' | translate }}</p> <kform-html-element component=\"component\"></kform-html-element> ";
// Exports
export default code;